import React from "react";
import Module from "components/loadable-modules";
import { isMobileOnly } from "react-device-detect";
import useIsClient from "hooks/useIsClient";

const RenderLoadableModules = (modules) => {
  if (!modules) return;

  const isClient = useIsClient();

  const descendingSort = (a,b) => a.mobileIndex - b.mobileIndex;
  const mobileModules = [...modules].sort(descendingSort).filter(module => !module.hideMobile);
  const desktopModules = modules.filter(module => !module.hideDesktop);
  // const allModules = modules.filter(module => module.hideDesktop === undefined || module.hideMobile === undefined);

  if(isMobileOnly && isClient)
    return mobileModules?.map((module) => (
      <Module
        key={module._key}
        type={module._type}
        moduleData={module} />)
    );

  return desktopModules?.map((module) => (
    <Module
      key={module._key}
      type={module._type}
      moduleData={module} />)
  );
};

export default RenderLoadableModules;
